module.exports = __webpack_public_path__ + "static/media/memory-app.d91f520b.png";